import OnestockActionCenterContainer from "./OnestockActionCenterContainer";
import OnestockActionCenterStore from "./OnestockActionCenterStore";

export default OnestockActionCenterStore(OnestockActionCenterContainer);